import { union } from 'lodash';
import * as actionTypes from './actionTypes';
import { getItemsBetweenIndex } from '../../../../utils/helper';

// Init state
export const subscriptionsMainState = {
  isLoading: true,
  isLoadingTable: false,
  isLoadingPagination: false,
  updateList: false,
  isInitPage: false,
  initPageError: null,

  search: '',
  searchOption: null,
  modal: null,
  filters: {
    query: null,
    search_type: null,
    status: null,
    delay: null,
    service: null,
  },
  pagination: null,
  subscriptions: [],
  statuses: [],
  configuration: null,
  sort: {},
  checked: [],
  lastCheckedIndex: null,
  delays: {
    isLoading: false,
    data: [],
  },
  service: {
    isLoading: false,
    data: [],
  },
};

export const subscriptionsMainReducer = (state, action) => {
  const { payload } = action;
  switch (action.type) {
  case actionTypes.SUBSCRIPTIONS_LOADING_TABLE:
    return {
      ...state,
      isLoadingTable: true,
    };
  case actionTypes.SUBSCRIPTIONS_UPDATE_SEARCH:
    return {
      ...state,
      isLoadingTable: true,
      filters: payload.filters,
      sort: {
        ...state.sort,
        columns: payload.sortColumns,
      },
    };
  case actionTypes.SUBSCRIPTIONS_LIST_UPDATE:
    return {
      ...state,
      isLoadingTable: true,
      updateList: true,
    };
  case actionTypes.SUBSCRIPTIONS_LIST_UPDATE_SUCCESS:
    return {
      ...state,
      checked: [],
      isLoadingTable: false,
      updateList: false,
      pagination: payload.pagination,
      subscriptions: payload.subscriptions,
      filters: payload.filters,
      sort: payload.sort,
    };
  case actionTypes.SUBSCRIPTIONS_PAGINATION_UPDATE:
    return {
      ...state,
      isLoadingPagination: true,
    };
  case actionTypes.SUBSCRIPTIONS_PAGINATION_UPDATE_SUCCESS:
    return {
      ...state,
      pagination: payload,
      isLoadingPagination: false,
    };
  case actionTypes.SUBSCRIPTIONS_PAGINATION_UPDATE_ERROR:
    return {
      ...state,
      isLoadingPagination: false,
    };
  case actionTypes.SUBSCRIPTIONS_LIST_UPDATE_ERROR:
    return {
      ...state,
      isLoadingTable: false,
      isLoadingPagination: false,
      isInitPage: true,
      initPageError: {
        data: payload.data,
        status: payload.status,
        statusText: payload.statusText,
      },
    };
  case actionTypes.SUBSCRIPTIONS_LIST_SUCCESS:
    return {
      ...state,
      isInitPage: true,
      initPageError: null,
      isLoadingTable: false,
      search_types: payload.search_types,
      pagination: payload.pagination,
      configuration: payload.configuration,
      subscriptions: payload.subscriptions,
      statuses: payload.statuses.map((status) => {
        switch (status.code) {
        case 'active':
        case 'pause':
        case 'finished':
        case 'stopped':
        case 'expired':
          return {
            ...status,
            count: 0,
          };
        default:
          return status;
        }
      }),
      filters: payload.filters,
      sort: payload.sort,
      delays: {
        ...state.delays,
        data: payload.delays,
      },
      service: {
        ...state.service,
        data: payload.services.map((service) => {
          const { id, title } = service;
          return {
            id,
            label: title,
          };
        }),
      },
    };
  case actionTypes.SUBSCRIPTIONS_GET_DELAYS_FILTER:
    return {
      ...state,
      delays: {
        ...state.delays,
        isLoading: true,
      },
    };
  case actionTypes.SUBSCRIPTIONS_GET_DELAYS_FILTER_SUCCESS:
    return {
      ...state,
      delays: {
        ...state.delays,
        isLoading: false,
        data: payload.data,
      },
    };
  case actionTypes.SUBSCRIPTIONS_GET_DELAYS_FILTER_ERROR:
    return {
      ...state,
      delays: {
        ...state.delays,
        isLoading: false,
      },
    };
  case actionTypes.SUBSCRIPTIONS_GET_DELAYS_FILTER_CLEAR:
    return {
      ...state,
      delays: {
        ...state.delays,
        data: [],
      },
    };
  case actionTypes.SUBSCRIPTIONS_GET_SERVICE_FILTER:
    return {
      ...state,
      service: {
        ...state.service,
        isLoading: true,
      },
    };
  case actionTypes.SUBSCRIPTIONS_GET_SERVICE_FILTER_SUCCESS:
    return {
      ...state,
      service: {
        ...state.service,
        isLoading: false,
        data: payload.data,
      },
    };
  case actionTypes.SUBSCRIPTIONS_GET_SERVICE_FILTER_ERROR:
    return {
      ...state,
      service: {
        ...state.service,
        isLoading: false,
      },
    };
  case actionTypes.SUBSCRIPTIONS_CHECKED_ADD:
    return {
      ...state,
      lastCheckedIndex: payload.index,
      checked: [...state.checked, payload.id],
    };
  case actionTypes.SUBSCRIPTIONS_CHECKED_ADD_SHIFT:
    const addedItems = getItemsBetweenIndex(
      state.subscriptions,
      state.lastCheckedIndex,
      payload.index,
      (subscription) => subscription.status !== 3,
    );
    return {
      ...state,
      lastCheckedIndex: payload.index,
      checked: union(state.checked, addedItems),
    };
  case actionTypes.SUBSCRIPTIONS_CHECKED_ADD_ID:
    return {
      ...state,
      checked: payload.checked,
    };
  case actionTypes.SUBSCRIPTIONS_CHECKED_DELETE:
    return {
      ...state,
      lastCheckedIndex: payload.index,
      checked: state.checked.filter((id) => id !== payload.id),
    };
  case actionTypes.SUBSCRIPTIONS_CHECKED_DELETE_SHIFT:
    const deletedItems = getItemsBetweenIndex(state.subscriptions, state.lastCheckedIndex, payload.index);
    return {
      ...state,
      lastCheckedIndex: payload.index,
      checked: state.checked.filter((id) => !deletedItems.includes(id)),
    };
  case actionTypes.SUBSCRIPTIONS_CHECKED_MASS_DELETE:
    return {
      ...state,
      checked: [],
    };
  case actionTypes.SUBSCRIPTIONS_CHECKED_MASS_ADD:
    return {
      ...state,
      checked: state.subscriptions.filter((subscription) => subscription.status !== 3).map((service) => service.id),
    };
  case actionTypes.SUBSCRIPTIONS_CHANGE_FILTER:
    return {
      ...state,
      isLoadingTable: true,
    };
  case actionTypes.SUBSCRIPTIONS_CHANGE_FILTER_TYPE:
    return {
      ...state,
      isLoadingTable: true,
      filters: {
        ...state.filters,
        type: payload.type,
      },
      checked: [],
    };
  case actionTypes.SUBSCRIPTIONS_CHANGE_FILTER_QUERY:
    return {
      ...state,
      isLoadingTable: true,
      filters: {
        ...state.filters,
        query: payload.query,
      },
      checked: [],
    };
  case actionTypes.SUBSCRIPTIONS_CHANGE_FILTER_SEARCH_TYPE:
    return {
      ...state,
      isLoadingTable: !!state.filters.query,
      filters: {
        ...state.filters,
        search_type: payload.searchType,
      },
      checked: state.filters.query ? [] : state.checked,
    };
  case actionTypes.SUBSCRIPTIONS_MODAL_CLOSE:
    return {
      ...state,
      modal: null,
    };
  case actionTypes.SUBSCRIPTIONS_MODAL_OPEN:
    return {
      ...state,
      modal: {
        name: payload.name,
        data: payload.data,
      },
    };
  case actionTypes.SUBSCRIPTIONS_CHANGE_PAGE:
    return {
      ...state,
      isLoadingTable: true,
      pagination: {
        ...state.pagination,
        current_page: Number(payload.page),
      },
      checked: [],
    };
  case actionTypes.SUBSCRIPTIONS_RESEND:
    return {
      ...state,
      isLoadingTable: true,
    };
  case actionTypes.SUBSCRIPTIONS_RESEND_SUCCESS:
    return {
      ...state,
      isLoadingTable: true,
      updateList: true,
    };
  case actionTypes.SUBSCRIPTIONS_RESEND_ERROR:
    return {
      ...state,
      isLoadingTable: false,
    };
  case actionTypes.SUBSCRIPTIONS_CHANGE_STATUS_SUCCESS:
  case actionTypes.SUBSCRIPTIONS_CHANGE_EXPIRY_SUCCESS:
    return {
      ...state,
      isLoadingTable: true,
      updateList: true,
      modal: null,
    };
  case actionTypes.SUBSCRIPTIONS_CHANGE_STATUSES_SUCCESS:
    return {
      ...state,
      isLoadingTable: true,
      updateList: true,
      modal: null,
      checked: [],
    };
  case actionTypes.SUBSCRIPTIONS_CHANGE_SORT:
    return {
      ...state,
      isLoadingTable: true,
      filters: {
        ...state.filters,
        sort: payload.sort,
      },
      checked: [],
    };
  default:
    throw new Error();
  }
};

// Action creator
export function listSuccess(payload) {
  return { type: actionTypes.SUBSCRIPTIONS_LIST_SUCCESS, payload };
}

export function loadingTable() {
  return { type: actionTypes.SUBSCRIPTIONS_LOADING_TABLE };
}

export function loadingTablePagination() {
  return { type: actionTypes.SUBSCRIPTIONS_PAGINATION_UPDATE };
}

export function updateSearch(filters, sortColumns) {
  return { type: actionTypes.SUBSCRIPTIONS_UPDATE_SEARCH, payload: { filters, sortColumns } };
}

export function updateListSuccess(payload) {
  return { type: actionTypes.SUBSCRIPTIONS_LIST_UPDATE_SUCCESS, payload };
}

export function updatePaginationSuccess(payload) {
  return { type: actionTypes.SUBSCRIPTIONS_PAGINATION_UPDATE_SUCCESS, payload };
}

export function updateListError(data, status, statusText) {
  return {
    type: actionTypes.SUBSCRIPTIONS_LIST_UPDATE_ERROR,
    payload: {
      data,
      status,
      statusText,
    },
  };
}

export function tableSort(sort) {
  return { type: actionTypes.SUBSCRIPTIONS_CHANGE_SORT, payload: { sort } };
}

export function getDelaysFilter() {
  return { type: actionTypes.SUBSCRIPTIONS_GET_DELAYS_FILTER };
}
export function getDelaysFilterSuccess(data) {
  return { type: actionTypes.SUBSCRIPTIONS_GET_DELAYS_FILTER_SUCCESS, payload: { data } };
}
export function getDelaysFilterError() {
  return { type: actionTypes.SUBSCRIPTIONS_GET_DELAYS_FILTER_ERROR };
}
export function delaysFilterClear() {
  return { type: actionTypes.SUBSCRIPTIONS_GET_DELAYS_FILTER_CLEAR };
}
export function getServiceFilter() {
  return { type: actionTypes.SUBSCRIPTIONS_GET_SERVICE_FILTER };
}
export function getServiceFilterSuccess(data) {
  return { type: actionTypes.SUBSCRIPTIONS_GET_SERVICE_FILTER_SUCCESS, payload: { data } };
}
export function getServiceFilterError() {
  return { type: actionTypes.SUBSCRIPTIONS_GET_SERVICE_FILTER_ERROR };
}

export function resendSubscription() {
  return { type: actionTypes.SUBSCRIPTIONS_RESEND };
}

export function resendSubscriptionSuccess() {
  return { type: actionTypes.SUBSCRIPTIONS_RESEND_SUCCESS };
}

export function checkedMassAdd() {
  return { type: actionTypes.SUBSCRIPTIONS_CHECKED_MASS_ADD };
}

export function checkedMassDelete() {
  return { type: actionTypes.SUBSCRIPTIONS_CHECKED_MASS_DELETE };
}

export function changeStatusSuccess() {
  return { type: actionTypes.SUBSCRIPTIONS_CHANGE_STATUS_SUCCESS };
}

export function changeStatusesSuccess() {
  return { type: actionTypes.SUBSCRIPTIONS_CHANGE_STATUSES_SUCCESS };
}

export function changeExpirySuccess() {
  return { type: actionTypes.SUBSCRIPTIONS_CHANGE_EXPIRY_SUCCESS };
}

export function checkedAdd(id, index) {
  return { type: actionTypes.SUBSCRIPTIONS_CHECKED_ADD, payload: { id, index } };
}

export function checkedAddShift(id, index) {
  return { type: actionTypes.SUBSCRIPTIONS_CHECKED_ADD_SHIFT, payload: { id, index } };
}

export function checkedDelete(id, index) {
  return { type: actionTypes.SUBSCRIPTIONS_CHECKED_DELETE, payload: { id, index } };
}

export function checkedDeleteShift(id, index) {
  return { type: actionTypes.SUBSCRIPTIONS_CHECKED_DELETE_SHIFT, payload: { id, index } };
}

export function changePage(page) {
  return { type: actionTypes.SUBSCRIPTIONS_CHANGE_PAGE, payload: { page } };
}

export function modalClose() {
  return { type: actionTypes.SUBSCRIPTIONS_MODAL_CLOSE };
}

export function modalOpen(name, data) {
  return { type: actionTypes.SUBSCRIPTIONS_MODAL_OPEN, payload: { name, data } };
}
